import * as React from 'react';
import {Shop} from 'interfaces/Shop';
import {Icon} from 'components/UIKit/Icon';
import DesktopNewTabAnchor from 'components/DesktopNewTabAnchor';
import shopIcons from 'components/ShopDisplay/icons';
import {ShopMetric} from 'components/ShopDisplay';

export interface Props {
  shop: Shop;
}

export default function ShopMetrics(props: Props) {
  const {
    averageProfitPerMonth,
    inventoryValue,
    shopifyShopRecord,
    starterShop,
  } = props.shop;

  if (starterShop) {
    return (
      <div className="shop-tile__content shop-tile__metrics-container shop-tile__starter-indicator background-off-white">
        <Icon
          className="shop-tile__starter-icon"
          sourceSVG={shopIcons.store}
          fill="#919eab"
        />
        Starter store
      </div>
    );
  } else {
    return (
      <DesktopNewTabAnchor href={`/shops/${props.shop.handle}`}>
        <div className="shop-tile__content shop-tile__metrics-container">
          <ShopMetric
            asterisk
            qualifier="Revenue"
            value={shopifyShopRecord.averageMonthlyRevenue}
            currency
            monthByMonth={shopifyShopRecord.monthByMonthRevenue}
          />

          <ShopMetric
            asterisk
            qualifier="Traffic"
            value={shopifyShopRecord.averageMonthlyTraffic}
            currency={false}
            monthByMonth={shopifyShopRecord.monthByMonthTraffic}
          />

          <ShopMetric
            asterisk
            qualifier="Profit"
            value={averageProfitPerMonth}
            currency
            monthByMonth={null}
          />

          <ShopMetric
            asterisk={false}
            qualifier="Inventory Value"
            value={inventoryValue}
            currency
            monthByMonth={null}
          />

          <div className="shop-tile__metric__footnote">
            *monthly averages
          </div>
        </div>
      </DesktopNewTabAnchor>
    );
  }
}
